import React from 'react';

interface Props {
  isActive: boolean;
  name: string;
  onClick: () => void;
}

export default function ProjectsListGroupItem({
  isActive,
  name,
  onClick,
}: Props) {
  const activeClass = isActive ? 'active' : '';

  return (
    <a
      href="#"
      className={`list-group-item list-group-item-action d-flex justify-content-between align-items-center ${activeClass}`}
      onClick={e => {
        e.preventDefault();
        onClick();
      }}
    >
      {name}
    </a>
  );
}
